import React, { useMemo } from "react";
import TechItem from "./TechItem";
import { useSelector } from "react-redux";

const TechListEmpty = () => (
  <div className="empty">
    <img src="/assets/images/empty-tech.png" alt="empty" />
    <div className="text">
      Please select location and time to see available technicians
    </div>
  </div>
);

const List = ({ technicians_for_job }) => {
  return technicians_for_job?.map((item) => (
    <TechItem key={item?.id} item={item}/>
  ));
};

export default function TechList() {
  const {
    tech: { date, time },
    technicians_for_job,
  } = useSelector((state) => state.rootReducer.scheduleSlice);

  const memoizedTechList = useMemo(
    () => technicians_for_job,
    [date, time, technicians_for_job]
  );

  return (
    <>
      <div className="tech__list-label">Select technician</div>
      {memoizedTechList?.length > 0 && (
        <div className="tech__list-descr">
          <img src="/assets/icons/gray-tooltip.svg" alt="tooltip" />
          <label htmlFor="">
            If your job takes more then 10 hours to complete, please schedule another job
          </label>
        </div>
      )}
      <div className="tech__list">
        <div className="tech__list-body">
          {date && time && memoizedTechList?.length > 0 ? (
            <List technicians_for_job={memoizedTechList} />
          ) : (
            <TechListEmpty />
          )}
        </div>
      </div>
    </>
  );
}
